import React from 'react';

export const BrandWatermark = () => (
  <div className="fixed bottom-4 right-4 z-40 pointer-events-none opacity-30 flex items-center space-x-2" data-testid="brand-watermark">
    <img src="/brand_logo.png" alt="" className="w-28" />
  </div>
);

export const BrandHeader = () => (
  <div className="flex items-center justify-center mb-6 opacity-60" data-testid="brand-header">
    <img src="/brand_logo.png" alt="Trading Alienígena" className="h-10" />
  </div>
);
